import { AxiosResponse } from "axios";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";
import { Button, Container, Modal, Tooltip, Whisper } from "rsuite";
import { EPInput } from "../../common/controls";
import { changePassRoute } from "../../common/utils/api";
import { CommonConstants } from "../../common/utils/CommonConstants";
import { axiosPost } from "../../common/utils/helper";
import Loader from "../Loader/loader";
import { Row, Col } from "react-bootstrap";
import "../login/login.scss";

interface IChangePasswordModelProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

interface IPasswordDetail {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}
const ObjPasswordDetail = {
  oldPassword: "",
  newPassword: "",
  confirmNewPassword: "",
};

const ChangePasswordModel = (props: IChangePasswordModelProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { open, setOpen } = props;
  const [passwordDetail, setPasswordDetail] =
    useState<IPasswordDetail>(ObjPasswordDetail);
  const [isValidate, setIsValidate] = useState(false);

  const [displayOldPassword, setDisplayOldPassword] = useState(false);
  const [displayPassword, setDisplayPassword] = useState(false);
  const [displayConfirmPassword, setDisplayConfirmPassword] = useState(false);

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handleOnChange = (value: string, name: keyof IPasswordDetail) => {
    let data: IPasswordDetail = { ...passwordDetail };
    data[name] = value;
    setPasswordDetail(data);
  };

  const showOldPassword = () => setDisplayOldPassword(!displayOldPassword);
  const showPassword = () => setDisplayPassword(!displayPassword);
  const showConfirmPassword = () =>
    setDisplayConfirmPassword(!displayConfirmPassword);

  const validatePassword = () => {
    const { oldPassword, newPassword, confirmNewPassword } = passwordDetail;
    if (
      !oldPassword?.trim() ||
      !newPassword?.trim() ||
      !confirmNewPassword?.trim()
    ) {
      return { valid: false, message: "Please enter Passwords." };
    }
    if (!passwordRegex.test(newPassword) || newPassword?.trim()?.length > 30||!passwordRegex.test(oldPassword) || oldPassword?.trim()?.length > 30) {
      return {
        valid: false,
        message:
          "Password must be at least 8 characters long, including at least one uppercase letter, one lowercase letter, one number, and one special character.",
      };
    }
    if (newPassword !== confirmNewPassword) {
      return {
        valid: false,
        message: "New password and confirm password do not match.",
      };
    }

    return { valid: true };
  };

  function closeModal() {
    setPasswordDetail(ObjPasswordDetail)
    setOpen(false);
  }

  function handleSubmit() {
    setIsValidate(true);

    const { valid, message } = validatePassword();
    if (!valid) {
      return toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }

    setIsValidate(false);
    handleChangePassword();
  }

  const handleChangePassword = async () => {
    setLoading(true)
    const response: any = (await axiosPost(changePassRoute, {
      oldPassword: btoa(passwordDetail?.oldPassword),
      password: btoa(passwordDetail?.newPassword),
    })) as AxiosResponse;
    setLoading(false)
    if (
      response?.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response?.data?.status === "success"
    ) {
      toast.success("Password has been changed successfully.", {
        position: toast.POSITION.TOP_CENTER,
      });
      closeModal()
    } else if (
      response?.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response?.data?.status === "error"
    ) {
      toast.error(response?.data?.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  return loading ? (
    <Loader />
  ) : (
      <Modal
        open={open}
        onClose={closeModal}
        className="modal-sm"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title> Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
          <Row>
            <Col xs="12" lg="12" className="recruiter-label">
              Current Password <span className="req">*</span>
            </Col>

            <Col xs="12" lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <div className="form-group">
                  <div className="password">
                    <EPInput
                      placeholder="Old Password"
                      type={displayOldPassword ? "text" : "password"}
                      isValidate={isValidate}
                      onChange={(value: any) => {
                        handleOnChange(value, "oldPassword");
                      }}
                      minlength={8}
                      maxlength={30}
                      value={passwordDetail?.oldPassword}
                    />
                    <button
                      type="button"
                      className="password-icon"
                      onClick={showOldPassword}
                      aria-label="Toggle password visibility"
                    >
                      {displayOldPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                    </button>
                  </div>
                </div>
              </Whisper>
            </Col>
            <Col xs="12" lg="12" className="recruiter-label">
              New Password<span className="req">* </span>
            </Col>
            <Col xs="12" lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <div className="form-group">
                  <div className="password">
                    <EPInput
                      placeholder="Password"
                      type={displayPassword ? "text" : "password"}
                      onChange={(value: any) => {
                        handleOnChange(value, "newPassword");
                      }}
                      isValidate={isValidate}
                      value={passwordDetail?.newPassword}
                      minlength={8}
                      maxlength={30}
                    />
                     <button
                      type="button"
                      className="password-icon"
                      onClick={showPassword}
                      aria-label="Toggle password visibility"
                    >
                      {displayPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                    </button>
                  </div>
                </div>
              </Whisper>
            </Col>
            <Col xs="12" lg="12" className="recruiter-label">
              Confirm Password<span className="req">* </span>
            </Col>
            <Col xs="12" lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <div className="form-group">
                  <div className="password">
                    <EPInput
                      placeholder="Confirm Password"
                      type={displayConfirmPassword ? "text" : "password"}
                      isValidate={isValidate}
                      onChange={(value: any) => {
                        handleOnChange(value, "confirmNewPassword");
                      }}
                      minlength={8}
                      maxlength={30}
                      value={passwordDetail?.confirmNewPassword}
                    />
                    <button
                      type="button"
                      className="password-icon"
                      onClick={showConfirmPassword}
                      aria-label="Toggle password visibility"
                    >
                      {displayConfirmPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                    </button>
                  </div>
                </div>
              </Whisper>
            </Col>
          </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleSubmit}
            className="float-start"
            appearance="primary"
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
  );
};

export default ChangePasswordModel;
